var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33 33",
    width: 33,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "currentColor",
    d: "m6.552 24.454 9.789-9.789c.367-.367.243-.666-.28-.665l-3.629.008c-1.883.003-1.878-2.822.004-2.825l8.049-.1a1.371 1.371 0 0 1 1.402 1.393l-.07 8.088c-.003 1.882-2.827 1.886-2.825.004l.007-3.63c.002-.522-.295-.647-.664-.279l-9.788 9.789c-.551.55-.492 1.377.135 1.84 0 0-.37-.244.029.02 5.49 3.63 12.954 3.027 17.789-1.808 5.523-5.522 5.523-14.477 0-20-5.523-5.524-14.478-5.524-20 0-4.841 4.84-5.44 12.315-1.796 17.807.26.393.006.01.006.01.455.632 1.289.69 1.842.136Zm-1.72 3.713c-6.443-6.443-6.443-16.89 0-23.334 6.444-6.444 16.891-6.444 23.335 0 6.444 6.443 6.444 16.89 0 23.334-6.443 6.444-16.89 6.444-23.334 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconSvg);
export default __webpack_public_path__ + "static/media/share-icon-svg.262d79fae6ef509f8d2dbb0ad22993ff.svg";
export { ForwardRef as ReactComponent };